<div class="mt-5 container-fluid">
  <div class="row justify-content-center">
    <div class="col-6 alert alert-warning">
      <h3>{{ 'global.components.viewport.warning_headline' | translate }}</h3>
      <h4>
       {{ pageName }} {{'global.components.viewport.warning_text' | translate: {resolution:resolution} }}</h4>
    </div>
  </div>
</div>